module.exports = __webpack_public_path__ + "static/img/sca.9e26b05.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sca.jpg
// module id = Y18h
// module chunks = 0